// extracted by mini-css-extract-plugin
module.exports = {"containerMain":"Category_containerMain__naYR_","buttons":"Category_buttons__Crgi0","active":"Category_active__RtL91"};